interface LogoProps {
  className?: string;
}

export function NasdaqTrackerLogo({ className = "w-full h-full" }: LogoProps) {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 50 50"
      className={className}
    >
      <path 
        fill="currentColor" 
        d="M27.6,25.4l2-3.6-4.6-9.4h-4.1s-15.1,27.2-15.1,27.2h3.8s13.3-23.9,13.3-23.9l4.7,9.7h0ZM40.4,10.4l-13.2,23.7-4.7-9.7-2,3.6,3.9,8h5.6s14.3-25.6,14.3-25.6h-3.8Z" 
      />
    </svg>
  );
}